/**
 * 
 * SmileLinks.js
 * 
 */


import React, { Component } from "react";
import { Nav } from 'react-bootstrap';




export class SmileLinks extends Component {

    


  navAnimate(id_name) {
    let element = document.getElementById(id_name); 
    if (element != null) {
        element.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
        // element.scrollV
    }
  }  

  render() {
    return (
        
        <Nav className="ml-auto" color="#dark">
          <Nav.Link style={{margin: '8px'}} onClick={ () => this.navAnimate("about")} ><p className="linkText">About Us</p></Nav.Link>
          <Nav.Link style={{margin: '8px'}} onClick={ () => this.navAnimate("problem")} ><p className="linkText">Problem</p></Nav.Link>
          <Nav.Link style={{margin: '8px'}} onClick={ () => this.navAnimate("solution")} ><p className="linkText">Our Solution</p></Nav.Link>
          <Nav.Link style={{margin: '8px'}} onClick={ () => this.navAnimate("demo")} ><p className="linkText">Demo</p></Nav.Link>
          <Nav.Link style={{margin: '8px'}} onClick={ () => this.navAnimate("contactus")} ><p className="linkText">Contact Us</p></Nav.Link>
        </Nav>

    );
  }


}
